module.exports = __webpack_public_path__ + "img/img4.8db2431e.svg";